import {Component, inject} from '@angular/core';
import {rxResource} from "@angular/core/rxjs-interop";
import {AuthenticationService} from '@services'
import {ArtworkService} from '@api-services'
import {TranslocoDirective} from "@jsverse/transloco";
import {of} from "rxjs";
import {DatePipe} from "@angular/common";
import {CalendarIconComponent} from "@icons";
import {MediaRenderComponent} from "../../../../components/media-render/media-render.component";
import {RouterLink, RouterOutlet} from "@angular/router";

@Component({
  selector: 'wun-evaluations',
  imports: [
    TranslocoDirective,
    DatePipe,
    CalendarIconComponent,
    MediaRenderComponent,
    RouterOutlet,
    RouterLink,
  ],
  templateUrl: './evaluations.component.html',
  styleUrl: './evaluations.component.scss'
})
export class EvaluationsComponent {

  private readonly authenticationService = inject(AuthenticationService);
  private readonly artworkService = inject(ArtworkService);
  artworks = rxResource({
    params: () => this.authenticationService.current(),
    stream: (data) => {
      if(!data.params) return of();
      return this.artworkService.artworksFindAndPaginate({
        pageSize: 1000,
        includes: JSON.stringify(['evaluation', 'mainAttachment']),
        filters: JSON.stringify({
          artist: data.params.id
        })
      })
    }
  })
}
